{
  "metrics": {
    "title": "Метрики залученості"
  },
  "involvement": {
    "title": "Залученість учасників",
    "empty": "Наразі недостатньо даних для статистично безпечного відображення результатів"
  },
  "balance": {
    "title": "Модель психологічної рівноваги",
    "details": {
      "title": "Детальніше",
      "content": "Це карта стану команди за 8 сферами. Вона показує, де, наразі зосереджено основні ресурси команди, а де є ризики перевантаження й втрати ефективності. Дані знеособлені й відображають лише загальну картину.\n\nНатисніть на будь-яку сферу, щоб побачити детальні показники та короткі пояснення, які допоможуть спланувати подальші кроки підтримки команди."
    },
    "empty": "Наразі недостатньо даних для статистично безпечного відображення результатів"
  },
  "wellbeing": {
    "title": "Рівень добробуту",
    "subtitle": "Розподіл користувачів за узагальненим показником добробуту. Дає змогу швидко оцінити частку критичних, середніх і ресурсних станів.",
    "avg": "Рівень добробуту",
    "critical": "Критичний рівень",
    "middle": "Середній рівень",
    "resource": "Ресурсний рівень",
    "empty": "Загальний рівень добробуту розраховується на основі результатів діагностики. Проінформуйте користувачів про важливість її проходження."
  },
  "scales": {
    "title": "Ключові шкали стану",
    "subtitle": "Середні значення за шкалами, які формують основу оцінки стану користувачів і відображають аспекти, що впливають на загальну продуктивність.",
    "more": "Детальніше",
    "close": "Закрити",
    "empty": "Шкали стану — це перший сигнал про те, що відбувається в команді. Щоб побачити дані, учасники мають завершити діагностику.",
    "scorePlural": {
      "one": "Бал",
      "few": "Бали",
      "many": "Балів"
    },
    "scoreDesc": "Шкала оцінюється від 0 до 100 балів: що вищий показник, то більш вираженими є відповідні прояви.",
    "scaleMeaning": "Що означає шкала?",
    "resultMeaning": "Що означає результат?"
  },
  "insights": {
    "title": "Інсайти",
    "subtitle": "Ключові висновки на основі даних про стан користувачів та виявлені тенденції.",
    "recommendation": "Рекомендація:"
  },
  "dangers": {
    "title": "Зони ризику",
    "subtitle": "Індикатори, що допомагають вчасно виявити ризики небезпечної поведінки.",
    "dangertoyourself": "Потенційна небезпека для себе",
    "dangertoother": "Потенційна небезпека для інших",
    "empty": "Цей блок відображає критичні сигнали, якщо вони є. Поки даних немає — це добра новина.",
    "suggestions": [
      {
        "title": "Забезпечте доступ до підтримки",
        "desc": "Переконайтесь, що всі учасники знають про доступні ресурси допомоги (гарячі лінії, психолог, wellbeing-програми, внутрішні або зовнішні сервіси) і розуміють, як ними скористатись."
      },
      {
        "title": "Посилюйте комунікацію та безпечне середовище",
        "desc": "Підтримуйте відкриту атмосферу, де допустимо говорити про труднощі. Підкреслюйте важливість взаємоповаги та нульову толерантність до агресивної поведінки, нагадуйте про відкритість до діалогу і важливість звернення по допомогу."
      }
    ]
  },
  "howareu": {
    "title": "Допомога від наших партнерів",
    "subtitle": "Всеукраїнська програма ментального здоров'я",
    "card": {
      "title": "Практичний гайд для роботодавців",
      "desc": "Практичний гайд, який допоможе перетворити турботу про ментальний стан команди на системні дії та ефективно використовувати результати діагностики.",
      "button": "Переглянути",
      "link": "https://drive.google.com/file/u/1/d/1obHFUecUEqWO-5I_jPRGbb6uKtCbjST4/view"
    }
  }
}
